import React from 'react'

import NonEmptyCartContextProvider from '../../../context/NonEmptyCartContextProvider'
import SharedBuyLayout from '../../../layouts/buy/SharedBuyLayout'
import Head from '../../../layouts/Head'
import BuyGlobalStyle from '../layout/BuyGlobalStyle'
import AgreementsContainer from './AgreementsContainer'

export const AgreementsPage = () => {
  return (
    <>
      <Head />
      <BuyGlobalStyle />
      <SharedBuyLayout>
        <NonEmptyCartContextProvider>
          <AgreementsContainer />
        </NonEmptyCartContextProvider>
      </SharedBuyLayout>
    </>
  )
}
